import { buildInlineComputedView } from "./../builder.js";
import { ClickhouseContactsNamespace } from "./clickhouse/contacts.js";
import { ClickhouseMessagesNamespace } from "./clickhouse/messages.js";
import { ClickhouseSegmentmembershipsNamespace } from "./clickhouse/segmentMemberships.js";
class ClickhouseNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "clickhouse",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
    this.contacts = new ClickhouseContactsNamespace(this);
    this.messages = new ClickhouseMessagesNamespace(this);
    this.segmentMemberships = new ClickhouseSegmentmembershipsNamespace(this);
  }
}
export {
  ClickhouseNamespace
};
//# sourceMappingURL=clickhouse.js.map
